'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlay = require('@alicd/next/lib/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _button = require('@alicd/next/lib/button');

var _button2 = _interopRequireDefault(_button);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require('@alicd/next/lib/grid');

var _grid2 = _interopRequireDefault(_grid);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;

var ProcessLoading = function (_React$Component) {
  (0, _inherits3.default)(ProcessLoading, _React$Component);

  function ProcessLoading(props) {
    (0, _classCallCheck3.default)(this, ProcessLoading);
    return (0, _possibleConstructorReturn3.default)(this, (ProcessLoading.__proto__ || (0, _getPrototypeOf2.default)(ProcessLoading)).call(this, props));
  }

  (0, _createClass3.default)(ProcessLoading, [{
    key: 'renderCancel',
    value: function renderCancel() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var hasCancel = props.hasCancel,
          onCancel = props.onCancel,
          locale = props.locale;

      if (hasCancel) {
        return _react2.default.createElement(
          Col,
          { className: 'loading-btn', fixedSpan: 3 },
          _react2.default.createElement(
            _button2.default,
            { onClick: onCancel, shape: 'text' },
            locale.cancel
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          message = _props.message,
          iconType = _props.iconType,
          onComplete = _props.onComplete,
          process = _props.process,
          locale = _props.locale,
          onCancel = _props.onCancel,
          hasCancel = _props.hasCancel,
          others = (0, _objectWithoutProperties3.default)(_props, ['className', 'message', 'iconType', 'onComplete', 'process', 'locale', 'onCancel', 'hasCancel']);

      if (className) {
        others.className = 'process-loading ' + className;
      } else {
        others.className = 'process-loading';
      }

      if (process >= 0.99) {
        onComplete(process);
      }
      return _react2.default.createElement(
        _overlay2.default,
        others,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            Row,
            { className: 'loading-row' },
            _react2.default.createElement(
              Col,
              { className: 'loading-msg' },
              _react2.default.createElement(_icon2.default, { type: iconType, style: { marginRight: 8 }, size: 'small' }),
              ' ',
              message
            ),
            this.renderCancel()
          ),
          _react2.default.createElement(
            'div',
            { className: 'loading-process-par' },
            _react2.default.createElement('i', { className: 'loading-process-bar', style: { width: process * 100 + '%' } })
          )
        )
      );
    }
  }]);
  return ProcessLoading;
}(_react2.default.Component);

ProcessLoading.timer = 0;
ProcessLoading.propTypes = {
  className: _propTypes2.default.string,
  message: _propTypes2.default.string,
  process: _propTypes2.default.number,
  iconType: _propTypes2.default.string,
  onCancel: _propTypes2.default.func,
  onComplete: _propTypes2.default.func,
  hasCancel: _propTypes2.default.bool
};
ProcessLoading.defaultProps = {
  process: 0,
  message: 'Loading …',
  align: 'cc cc',
  iconType: 'loading',
  onCancel: function onCancel() {},
  onComplete: function onComplete() {},
  hasCancel: true
};


var LocaleMyComponent = (0, _localeProvider2.default)(ProcessLoading);
LocaleMyComponent.LOCALE = {
  'en-us': {
    cancel: 'Cancel'
  },
  'zh-cn': {
    cancel: '取消'
  },
  'zh-tw': {
    cancel: '取消'
  }
};

exports.default = LocaleMyComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-process-loading@0.0.6@@alicd/crui-process-loading/lib/index.js
// module id = 649
// module chunks = 0